if (!customElements.get('email-signup-modal')) {
  customElements.define(
    'email-signup-modal',
    class EmailSignupModal extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.overlay = this.querySelector('[data-email-signup-overlay]');
        this.dialog = this.querySelector('[data-email-signup-dialog]');
        if (!this.overlay || !this.dialog) return;

        this.isOpen = false;
        this.delayMs = Math.max(0, Number(this.dataset.delay || 0)) * 1000;
        this.frequency = this.dataset.frequency || 'once_days';
        this.daysHidden = Math.max(0, Number(this.dataset.daysHidden || 14));
        this.showMobile = this.dataset.showMobile !== 'false';
        this.storageKey = this.dataset.storageKey || `email-signup-${this.id || 'default'}`;
        this.designMode = this.dataset.designMode === 'true';

        this.querySelectorAll('[data-email-signup-close]').forEach((button) => {
          button.addEventListener('click', () => this.close({ persist: true }));
        });

        this.overlay.addEventListener('click', (event) => {
          if (event.target === this.overlay) this.close({ persist: true });
        });

        this.onKeydown = (event) => {
          if (event.key === 'Escape' && this.isOpen) this.close({ persist: true });
        };
        document.addEventListener('keydown', this.onKeydown);

        if (this.designMode) {
          this.open();
          return;
        }

        const posted = this.querySelector('[data-email-signup-posted]');
        const postedState = posted?.getAttribute('data-email-signup-posted');
        if (postedState === 'success') {
          this.persist({ subscribed: true });
          this.open();
          return;
        }
        if (postedState === 'error') {
          this.open();
          return;
        }

        if (!this.showMobile && window.matchMedia('(max-width: 749px)').matches) return;
        if (!this.shouldShow()) return;

        this.timer = window.setTimeout(() => this.open(), this.delayMs);
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
        document.removeEventListener('keydown', this.onKeydown);
        if (this.isOpen) this.unlock();
      }

      shouldShow() {
        try {
          const raw = window.localStorage.getItem(this.storageKey);
          const data = raw ? JSON.parse(raw) : {};
          if (data.subscribed) return false;
          if (this.frequency === 'every_visit') return true;
          if (this.frequency === 'once_session') {
            return !window.sessionStorage.getItem(this.storageKey);
          }
          if (!data.dismissedAt) return true;
          const elapsedDays = (Date.now() - Number(data.dismissedAt)) / 86400000;
          return elapsedDays >= this.daysHidden;
        } catch {
          return true;
        }
      }

      open() {
        if (this.isOpen) return;
        this.isOpen = true;
        this.overlay.hidden = false;
        document.body.classList.add('overflow-hidden');
        const focusEl =
          this.dialog.querySelector('input[type="email"]') ||
          this.dialog.querySelector('[data-email-signup-close]') ||
          this.dialog;
        if (typeof trapFocus === 'function') {
          trapFocus(this.dialog, focusEl);
        } else if (typeof focusEl.focus === 'function') {
          focusEl.focus();
        }
      }

      close({ persist } = {}) {
        if (!this.isOpen) return;
        this.isOpen = false;
        this.overlay.hidden = true;
        this.unlock();
        if (persist && !this.designMode) this.persist({ dismissed: true });
      }

      unlock() {
        document.body.classList.remove('overflow-hidden');
        if (typeof removeTrapFocus === 'function') removeTrapFocus();
      }

      persist({ subscribed, dismissed } = {}) {
        try {
          const raw = window.localStorage.getItem(this.storageKey);
          const data = raw ? JSON.parse(raw) : {};
          if (subscribed) data.subscribed = true;
          if (dismissed || subscribed) data.dismissedAt = Date.now();
          window.localStorage.setItem(this.storageKey, JSON.stringify(data));
          if (this.frequency === 'once_session' && dismissed) {
            window.sessionStorage.setItem(this.storageKey, '1');
          }
        } catch {
          /* private mode / blocked storage */
        }
      }
    }
  );
}
